import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import './AccountsPagination.css'

class AccountsPagination extends Component {
    render() {
        return (
            <div className="pagination-div">
                <div className="pagination">
                    <ReactPaginate previousLabel={"‹"}
                                   nextLabel={"›"}
                                   breakLabel={<a>...</a>}
                                   breakClassName={"ellipsis disabled"}
                                   forcePage={this.props.page}
                                   onPageChange={this.props.handlePageChange}
                                   pageCount={this.props.total_pages}
                                   marginPagesDisplayed={1}
                                   pageRangeDisplayed={3}
                                   containerClassName={"pagination"}
                                   subContainerClassName={"pages pagination"}
                                   activeClassName={"active"}
                    />
                </div>
            </div>
        );
    }

}

export default AccountsPagination;



// WEBPACK FOOTER //
// ./src/accounts/components/AccountsPagination.js